export enum SETUP_STEP {
  DETAILS = "DETAILS",
  AUDIENCE = "AUDIENCE",
  INSIGHTS = "INSIGHTS",
  REVIEW = "REVIEW",
  FINISHED = "FINISHED",
}

export const steps: readonly SETUP_STEP[] = [
  SETUP_STEP.DETAILS,
  SETUP_STEP.AUDIENCE,
  SETUP_STEP.INSIGHTS,
  SETUP_STEP.FINISHED,
] as const;

export enum SetupStep {
  DETAILS = 0,
  AUDIENCE = 1,
  INSIGHTS = 2,
  FINISHED = 3,
}
